var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"wrapper"}},[_c('SidebarView'),_c('div',{staticClass:"d-flex flex-column",attrs:{"id":"content-wrapper"}},[_c('div',{attrs:{"id":"content"}},[_c('TopbarView'),_c('div',{staticClass:"container-fluid"},[_c('member-view',{attrs:{"id":_vm.id}})],1)],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }